import React from 'react';
import { ChevronGlyph } from './treeIcons';

/**
 * A group label inside the tree — "PINNED", "ALL DOCUMENTS" — per the reading
 * view artboard: 28 px, 11 px caps, a chevron that collapses the group and, on
 * the right, an optional count in tabular figures.
 */
export default function GroupHeader({ label, count = null, collapsed, onToggle }) {
  return (
    <button type="button" className="doc-group-header" aria-expanded={!collapsed} onClick={onToggle}>
      <ChevronGlyph size={14} className={`doc-group-chevron${collapsed ? '' : ' doc-group-chevron--open'}`} />
      <span className="doc-group-label">{label}</span>
      {count != null && <span className="doc-group-count">{count}</span>}
    </button>
  );
}
